import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Modal, ModalFuss } from "./Modal.js";
export function useBestaetigung() {
    const [offen, setOffen] = useState(null);
    const offenRef = useRef(null);
    const antworten = useCallback((ja) => {
        const frage = offenRef.current;
        if (frage === null)
            return;
        offenRef.current = null;
        setOffen(null);
        frage.aufloesen(ja);
    }, []);
    const bestaetigen = useCallback((frage) => {
        if (offenRef.current !== null)
            return Promise.resolve(false);
        return new Promise((aufloesen) => {
            const eintrag = { ...frage, aufloesen };
            offenRef.current = eintrag;
            setOffen(eintrag);
        });
    }, []);
    // Aushängen mit offener Frage: abgelehnt — die Aktion, die sie schützte, ist ohnehin fort.
    useEffect(() => () => {
        const frage = offenRef.current;
        offenRef.current = null;
        frage?.aufloesen(false);
    }, []);
    const bestaetigung = offen === null ? null : createPortal(_jsx(Bestaetigung, { frage: offen, onAntwort: antworten }), document.body);
    return { bestaetigen, bestaetigung };
}
function Bestaetigung(p) {
    const text = useRef(null);
    const gefaehrlich = p.frage.gefaehrlich === true;
    /*
     * Einstiegsfokus NACH dem Öffnen (Effekt, nicht Layout-Effekt: `Modal` öffnet im
     * Layout-Effekt, und `showModal` setzt den Fokus selbst auf den ersten Knopf).
     */
    useEffect(() => {
        const host = text.current?.closest("me-dialog");
        const ziel = host?.querySelector(gefaehrlich ? ".ki-modal__knopf" : ".ki-modal__primaer");
        ziel?.focus();
    }, [gefaehrlich]);
    return (_jsxs(Modal, { titel: p.frage.titel, gestapelt: true, onAbbrechen: () => p.onAntwort(false), children: [_jsx("div", { ref: text, className: "ki-bestaetigung__text", children: typeof p.frage.text === "string"
                    ? _jsx("p", { className: "ki-rueckfrage__text", children: p.frage.text }) : p.frage.text }), _jsx(ModalFuss, { speichernText: p.frage.bestaetigenText, onSpeichern: () => p.onAntwort(true), onAbbrechen: () => p.onAntwort(false) })] }));
}
//# sourceMappingURL=useBestaetigung.js.map